<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-form-radio-group :stacked="!properties.showInline">
        <b-form-radio
          :value="option"
          :key="optionIndex"
          :class="properties.showInline ? 'mr-3' : ''"
          v-for="(option, optionIndex) in Array.isArray(fBOptions)
            ? fBOptions
            : []"
          >{{ option }}</b-form-radio
        >
      </b-form-radio-group>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <single-choice-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-radio-group
        v-model="controlValue"
        :stacked="!properties.showInline"
      >
        <b-form-radio
          style="font-size: 14px"
          :value="option"
          :key="optionIndex"
          :class="properties.showInline ? 'mr-3' : ''"
          v-for="(option, optionIndex) in computedConditions.options
            ? Array.isArray(computedPropertiesForm.options)
              ? computedPropertiesForm.options
              : []
            : Array.isArray(properties.options)
            ? properties.options
            : []"
          >{{ option }}</b-form-radio
        >
      </b-form-radio-group>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
    >
      <div :class="properties.showInline ? 'd-flex flex-row flex-wrap' : ''">
        <div
          :value="option"
          :key="optionIndex"
          v-for="(option, optionIndex) in computedConditions.options
            ? Array.isArray(computedPropertiesForm.options)
              ? computedPropertiesForm.options
              : []
            : Array.isArray(properties.options)
            ? properties.options
            : []"
          class="mr-3"
        >
          <b-icon-check-circle-fill
            class="text-primary"
            v-if="controlValue == option"
          /><b-icon-circle v-else /> {{ option }}
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import SingleChoiceV1Properties from "./SingleChoiceV1Properties.vue";
import collectionServer from "../../../../server/collection";
export default {
  name: "SingleChoiceV1",
  components: { SingleChoiceV1Properties },
  props: [
    "showType",
    "properties",
    "form",
    "id",
    "results",
    "formId",
    "page",
    "componentsIdSuffix"
  ],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {},
      fBOptions: [],
      toWatch: {
        hidden: null
      }
    };
  },
  mounted() {
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if (this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }
    if (this.showType == "form-builder") this.getFBOptions();

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", [
      "setFormSubmitterComponentValue",
      "computeFormSubmitterValue",
      "initializeComponentValue"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async getFBOptions() {
      if (typeof this.properties.options == "string") {
        let re = /\{\{collections.(?:(?!\}\}).)*\}\}/g;
        const matches = [...this.properties.options.matchAll(re)];
        if (
          matches.length == 1 &&
          this.properties.options.startsWith("{{") &&
          this.properties.options.endsWith("}}")
        ) {
          const collections = await collectionServer.query();
          const collection = collections.find(
            c =>
              c.name ==
              this.properties.options.slice(
                14,
                this.properties.options.length - 2
              )
          );
          this.fBOptions = collection?.data.items || [];
        } else this.fBOptions = this.properties.options;
      } else this.fBOptions = this.properties.options;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <fieldset aria-describedby="" class="form-group" style="${this.getComponentComputedProperties(
        "style"
      )}">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div class="${
            this.properties.showInline ? "d-flex flex-row flex-wrap" : ""
          }">
            ${(Array.isArray(this.getComponentComputedProperties("options"))
              ? this.getComponentComputedProperties("options")
              : []
            )
              .map(
                option => `
            <div style="font-size: 14px" class="mr-3">
              ${
                this.controlValue == option
                  ? '<i class="fas fa-check-circle text-primary"></i>'
                  : '<i class="far fa-circle"></i>'
              }

              ${option}
            </div>
            `
              )
              .join("")}
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", ["getFormSubmitterComponentValue"]),
    computedPropertiesForm() {
      return (
        this.$store.state.formSubmitter.form.computedProperties[this.id] ??
        this.properties
      );
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden;

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    "properties.options": function() {
      if (this.showType == "form-builder") this.getFBOptions();
    }
  }
};
</script>
